<template>
    <div :class="{hidden: !loading}">
        <loading></loading>
    </div>

    <form action="" class="form form--floating-label" :class="{hidden: loading}" @submit.prevent="formSubmit" ref='form' >
        <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.contact_name, error: submittedOnce && errors.contact_name}">
            <input
                    id="contact_name"
                    type="text"
                    v-model="formData.contact_name"
                    class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue "
            />
            <label for="contact_name" class="absolute left-2 transition-all px-1 text-blue-gray">
                Contact Name
            </label>
        </div>

        <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.email, error: submittedOnce && errors.email}">
            <input
                    id="email"
                    type="email"
                    v-model="formData.email"
                    class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
            />
            <label for="email" class="absolute left-2 transition-all px-1 text-blue-gray">
                Email
            </label>
        </div>

        <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.phone , error: submittedOnce && errors.phone}">
            <input
                    id="phone"
                    type="text"
                    v-model="formData.phone"
                    class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
            />
            <label for="phone" class="absolute left-2 transition-all px-1 text-blue-gray">
                Contact Phone
            </label>
        </div>

        <div class="input-container input-container--floating relative mb-5 " :class="{empty: !formData.message, error: submittedOnce && errors.message}">
            <textarea
                    id="message"
                    v-model="formData.message"
                    class="h-full w-full px-2 pt-3 transition-all border-blue-gray rounded text-blue">
            </textarea>

            <label for="message" class="absolute left-2 transition-all bg-white px-1 text-blue-gray">
                Message
            </label>
        </div>

        <div class="mt-10 flex items-center ">
            <button type="submit" class="btn">Send Message</button>
            <div
                    @click="goBack"
                    class="ml-4 text-red hover:text-red-hover font-light underline cursor-pointer">Cancel Form</div>
        </div>
    </form>
</template>

<script charset="utf-8">

import { values, join, get } from 'lodash';
import Loading from '../includes/Loading.vue';
import Vuex from 'vuex';

export default {


    data() {
        return {
            formData: {
                contact_name: '',
                phone: '',
                email: '',
                message: ''
            },

            loading: false,
            submittedOnce: false,
            errors: {
                contact_name: 'Contact name is required',
                phone: '',
                email: 'Email is required',
                message: 'Message is required',
            }
        }
    },

    components: {
        Loading
    },

    emits: ["submit-success"],

    computed: {
        ...Vuex.mapGetters('profile', {
            profile: 'profile'
        }),
    },

    watch: {
        formData: {
            handler(newVal){
                this.errors.contact_name = newVal.contact_name ? '' : 'First name is required';
                this.errors.phone   = (!newVal.phone || newVal.phone.length >= 7) ? '' : 'Phone need to have at least 7 numbers';
                this.errors.email   = newVal.email  ? '' : 'Email is required';
                this.errors.message   = newVal.email  ? '' : 'Email is required';
            },
            deep: true
        }
    },

    created() {
        if(this.profile.isAuth() && !this.profile.isSharpAdmin()){
            this.formData.contact_name  = this.profile.first_name +  ' ' + (this.profile.last_name ? this.profile.last_name : '');
            this.formData.phone  = this.profile.phone ? this.profile.phone : '';
            this.formData.email  = this.profile.email;
        }
    },

    methods: {
        ...Vuex.mapActions('equipments', {
            createContact: 'createContact'
        }),

        formSubmit() {
            this.submittedOnce = true;

            // do not submit if form has errors
            if (join(values(this.errors), '')) {
                return;
            }
            this.loading = true;
            let data = {
                'Contact Name': this.formData.contact_name,
                'Phone': this.formData.phone,
                'Email': this.formData.email,
                'Message': this.formData.message,
            }

            let warId = this.$route.query.war_id ?? this.$route.query.WAR_ID;
            if(warId){
                data['WAR ID'] = warId;
            }

            let serial = this.$route.query.serial ?? this.$route.query.SERIAL;
            if(serial){
                data['Serial'] = serial;
            }

            this.createContact(data)
            .then(() => {
                this.loading = false;
                this.$emit('submit-success');
            }).catch(err => {
                this.loading = false;
                this.errors = {
                    message: get(err, 'response.data.errors.0.message')
                }
            });
        },
        goBack() {
            this.$router.go(-1);
        }
    }
}
</script>
